import styled from 'styled-components';
import { CalanderIcon } from '../../components/icon/icon';
import { UserMainSection } from '../../components/user/home/user.home.section';
import { OrderSection } from '../../components/user/home/user.home.section.order';
import { NoticeSection } from '../../components/user/home/user.home.,section.notice';
import { todayDate } from '../../utils/util';
import { ManagerHomeSection } from '../../components/manager/manager.home.section';
import { useEffect, useState } from 'react';
import { fetchCompanyHomeData } from '../../api/home';

const testData = {
  workingType: '전일',
  companyName: '공주 우진',
  arrivalTime: '10시 30분',
  dayPrice: 700000,
  monthPrice: 3500000,
};

const fakeDate = [
  {
    companyName: '공주 우진',
    count: 3,
  },
  {
    companyName: '청주 한일',
    count: 2,
  },
  {
    companyName: '부강 주안',
    count: 2,
  },
  {
    companyName: '세종 금창',
    count: 1,
  },
  {
    companyName: '공주 우진',
    count: 3,
  },
];

const fakeData2 = [
  {
    title: '시스템 정기 점검 안내',
    date: '2024-06-22',
  },
  {
    title: '시스템 점건 안내',
    date: '2024-06-21',
  },
  {
    title: '시스템 오픈 안내',
    date: '2024-06-20',
  },
];

// CompanyScheduleDto 인터페이스 정의
interface CompanyScheduleDto {
  work: string; // 작업 형태
  target: string; // 도착시
  amount: number; // 금액
  wanted: string; // 수배 차량
}

// CommonNoticeDto 인터페이스 정의
interface CommonNoticeDto {
  title: string; // 공지 제목
  createdAt: string; // 공지 날짜
}

// CompanyHomeDto 인터페이스 정의
interface CompanyHomeDto {
  schedules: CompanyScheduleDto[]; // 작업 스케줄 리스트
  notices: CommonNoticeDto[]; // 공지 리스트
}

const ManagerHome = () => {
  const today = todayDate();
  const [data, setData] = useState<CompanyHomeDto>();

  console.log(data);

  useEffect(() => {
    const getHomeData = async () => {
      const response = await fetchCompanyHomeData();
      setData(response);
    };

    getHomeData();
  }, []);
  return (
    <Container>
      <section className="date">
        <div className="title">
          오늘의 일정
          <span>
            {data?.schedules && data?.schedules.length > 0
              ? data?.schedules.length
              : '0'}
          </span>
        </div>
        <div className="icon-box-wrap">
          <span className="icon-box">
            <CalanderIcon />
          </span>
          <span className="today">{today}</span>
        </div>
      </section>
      <ManagerHomeSection schedules={data?.schedules || []} />
      <NoticeSection notice={data?.notices || []} />
    </Container>
  );
};

export default ManagerHome;

//style
const Container = styled.div`
  padding: 0 1.5rem;
  .title {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    font-size: 1.6rem;
    font-weight: 600;
    span {
      min-width: 3rem;
      padding: 0.4rem 1.1rem 0.3rem;
      color: ${(props) => props.theme.textWhiteColor};
      background-color: ${(props) => props.theme.btnBlueColor};
      border-radius: 12rem;
      font-size: 1.2rem;
      min-height: 2.2rem;
    }
  }
  .date {
    display: flex;
    justify-content: space-between;
    padding: 1.1rem 0;
    .icon-box-wrap {
      display: flex;
      gap: 0.7rem;
      align-items: center;
      .icon-box {
        display: flex;
      }
      .today {
        font-size: 1.2rem;
        font-weight: 600;
        line-height: 1.5rem;
      }
    }
  }
`;
